import { render } from "./FamilyWards.vue?vue&type=template&id=921e0ca6&scoped=true"
import script from "./FamilyWards.vue?vue&type=script&lang=js"
export * from "./FamilyWards.vue?vue&type=script&lang=js"

import "./FamilyWards.vue?vue&type=style&index=0&id=921e0ca6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921e0ca6"]])

export default __exports__